<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <!-- Formulario para añadir un nuevo pago -->
        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate *ngIf="loaded && !isCaseClosed()">
          <div class="row align-items-end">
            <div class="col-md-6 mb-4">
              <label for="inputDescripcion" class="form-label" i18n>Descripción de hito procesal (*)</label>
              <input type="text" class="form-control" id="inputDescripcion" name="descripcion" #descripcion="ngModel"
                [(ngModel)]="nuevoHito.descripcion" required
                [ngClass]="{ 'is-invalid': (f.submitted && descripcion.invalid) || (descripcion.invalid && (descripcion.dirty || descripcion.touched))}">
            </div>

            <div class="col-md-2 mb-4">
              <label for="inputFecha" class="form-label" i18n>Fecha fin (*)</label>
              <input type="date" class="form-control" id="inputFecha" name="fecha" #fecha="ngModel"
                [(ngModel)]="nuevoHito['fecha']" required
                [ngClass]="{ 'is-invalid': (fecha.invalid && f.submitted) || (fecha.invalid && (fecha.dirty || fecha.touched)) }">
            </div>
            <div class="col-md-2 mb-4">
              <label for="inputHora" class="form-label" i18n>Hora fin (*)</label>
              <input type="time" class="form-control" id="inputHora" name="hora" #hora="ngModel"
                [(ngModel)]="nuevoHito['hora']" required
                [ngClass]="{ 'is-invalid': (hora.invalid && f.submitted) || (hora.invalid && (hora.dirty || hora.touched)) }">
            </div>


            <div class="col-md-2 text-end mb-4">
              <button type="submit" class="btn btn-primary waves-effect waves-light"
                [disabled]="f.invalid || disableOptions || disableAnadirHito"><span i18n>Añadir Hito</span></button>
            </div>
          </div>
        </form>

        <!-- Tabla de pagos -->
        <h5 class="section-title" i18n>Hitos procesales dentro de plazo</h5>
        <app-advanced-table *ngIf="loaded" [tableData]="records" [columns]="columns" [pagination]="true"
          [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
          (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)" [buttonLink]="buttonLink"
          [disableOptions]="disableOptions || disableAnadirHito" [buttonTitle]="buttonTitle"
          (deleteClick)="openDeleteModal($event)">
        </app-advanced-table>

        <h5 class="section-title" i18n>Hitos procesales fuera de plazo</h5>
        <!-- Tabla de pagos con dias_restantes Fuera de Plazo -->
        <app-advanced-table *ngIf="loaded" [tableData]="recordsFueraPlazo" [columns]="columns" [pagination]="true"
          [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
          (search)="searchDataFueraPlazo($event)" [isSortable]="true" (sort)="onSortFueraPlazo($event)"
          [buttonLink]="buttonLink" [disableOptions]="disableOptions || disableAnadirHito" [buttonTitle]="buttonTitle"
          (deleteClick)="openDeleteModal($event)">
        </app-advanced-table>

        <div id="status" *ngIf="!loaded && !error">
          <div class="spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
          {{ error }}
        </ngb-alert>
      </div>
    </div>
  </div>
</div>


<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
  <div class="confirm-delete-modal-content">
    <div class="confirm-delete-modal-header">
      <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
    </div>
    <div class="confirm-delete-modal-body">
      <p><span i18n>¿Estás seguro de que deseas borrar el hito de</span> {{ hitoToDelete?.descripcion }}?</p>
    </div>
    <div class="confirm-delete-modal-footer">
      <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
        (click)="confirmDelete()">
        <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
      </button>
      <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
        <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
      </button>
    </div>
  </div>
</div>